import { Role } from '@core/roles/models/role.enum';

export interface WalkMeData {
  userId: string;
  tenantId: string;
  applicationVersionNumber: string;
  utcDate: string;
  utcTime: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  companyName: string;
  role: string;
  featureAccess: string;
  locale: string;
  userCreationDaysElapsed: number;
  databaseCreationDaysElapsed: number;
  usersCount: number;
  isRootUser: boolean;
  salesforceId: string;
  isKaseya365: boolean;
  isAccountTrial: boolean;
  accountEnabledAutopay: boolean | null;
  isInternalUser?: boolean;
}

export const userRoleToWalkMeUserRole: Record<Role, string> = {
  [Role.Admin]: 'Admin',
  [Role.User]: 'User',
  [Role.BillingAndPurchasing]: 'Billing and Purchasing',
  [Role.CoManagedUser]: 'CoManagedUser',
};
